var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath11778(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.533,
    height: 19.014,
    viewBox: "0 0 27.533 19.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11778",
    "data-name": "Path 11778",
    d: "M20746.777,21473.238l-14.117-8.359v7.141l-11.955-7.141v17.229l11.955-7.465v7.465Z",
    transform: "translate(-20720.205 -21463.998)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath11778);
export default __webpack_public_path__ + "static/media/Path 11778.5ecf2cc57444d4eb3fa72dd7c6253797.svg";
export { ForwardRef as ReactComponent };